import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePopOrderLogInput,
    PopOrderLog,
    UpdatePopOrderLogInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PopOrderLogService {
    private amplifyClient = generateClient();
    constructor() {}

    async listPopOrderLogs(): Promise<PopOrderLog[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPopOrderLogs
                })
            ).data.listPopOrderLogs.items;
            if (data) return data as PopOrderLog[];
        } catch (error) {
            console.error('Error finding PopOrderLog:', error);
            return null;
        }
    }

    async popOrderLogsByOrder(orderId: string): Promise<PopOrderLog[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.PopOrderLogsByOrder,
                    variables: {
                        orderId
                    }
                })
            ).data.PopOrderLogsByOrder.items;
            if (data) return data as PopOrderLog[];
        } catch (error) {
            console.error('Error finding PopOrderLog:', error);
            return null;
        }
    }

    async createPopOrderLog(
        input: CreatePopOrderLogInput
    ): Promise<PopOrderLog> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.createPopOrderLog,
                    variables: {
                        input
                    }
                })
            ).data.createPopOrderLog;
            if (date) return date as PopOrderLog;
        } catch (error) {
            console.error('Error creating PopOrderLog:', error);
            return null;
        }
    }

    async updatePopOrderAuthorizer(
        input: UpdatePopOrderLogInput
    ): Promise<PopOrderLog> {
        try {
            const date = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePopOrderLog,
                    variables: {
                        input
                    }
                })
            ).data.updatePopOrderLog;
            if (date) return date as PopOrderLog;
        } catch (error) {
            console.error('Error updated PopOrderLog:', error);
            return null;
        }
    }
}
